import { styled } from '@mui/material/styles';
import { COLUMN_INDICATOR_ADJUSTMENT } from './ContentColumns.util';

const PREFIX = 'ContentColumns';

export const classes = {
  absolute: `${PREFIX}-absolute`,
  columnsContent: `${PREFIX}-columnsContent`,
  borderedLeft: `${PREFIX}-borderedLeft`,
  borderedRight: `${PREFIX}-borderedRight`,
  separator: `${PREFIX}-separator`,
  divider: `${PREFIX}-divider`,
  brace: `${PREFIX}-brace`,
  braceLeft: `${PREFIX}-braceLeft`,
  braceRight: `${PREFIX}-braceRight`,
};

/* Migrated from ContentColumns.styles.ts */
const commonStylesBorders = (backgroundColor: string) => ({
  backgroundColor,
  bottom: `calc(-${COLUMN_INDICATOR_ADJUSTMENT} + 2.5px)`,
  // position: 'absolute',
  top: COLUMN_INDICATOR_ADJUSTMENT,
  width: '2px',
  zIndex: 1,
});

export const Root = styled('div')(({ theme }) => ({
  [`& .${classes.absolute}`]: {
    position: 'absolute',
  },

  [`& .${classes.columnsContent}`]: {
    position: 'relative',
  },

  [`& .${classes.borderedLeft}`]: {
    ...commonStylesBorders(theme.palette.primary.main),
    left: 0,
  },

  [`& .${classes.borderedRight}`]: {
    ...commonStylesBorders(theme.palette.primary.main),
    right: 0,
  },

  [`& .${classes.separator}`]: {
    position: 'absolute',
    backgroundColor: '#8A9097',
    zIndex: 1,
    width: '2px',
  },

  [`& .${classes.divider}`]: {
    position: 'absolute',
    backgroundColor: theme.palette.primary.main,
    zIndex: 1,
    width: '4px',
  },

  [`& .${classes.brace}`]: {
    position: 'absolute',
    backgroundColor: '#8A9097',
    zIndex: 1,
    top: 16,
    height: 2,
    '&:before, &:after': {
      content: '""',
      width: 20,
      height: 12,
      position: 'absolute',
      borderTop: '2px solid #8A9097',
    },
  },

  [`& .${classes.braceLeft}`]: {
    '&:before': {
      borderTopLeftRadius: 20,
      left: -20,
    },
  },

  [`& .${classes.braceRight}`]: {
    '&:after': {
      borderTopRightRadius: 20,
      right: -20,
    },
  },
}));